/**
 * SessionFormShared.jsx — Wave 1u3 refactor step 2 (FE).
 *
 * Tiny shared helpers used by SessionFormDialog and its sub-components.
 */
import React from 'react';

export const inputCls =
  "w-full h-10 px-3 rounded-xl bg-[#F6F7FB] border border-[#EFF0F6] text-[13px] " +
  "focus:bg-white focus:border-[#4F46E5] focus:ring-2 focus:ring-[#EDE8FF] outline-none transition-colors";

export const textareaCls =
  "w-full px-3 py-2 rounded-xl bg-[#F6F7FB] border border-[#EFF0F6] text-[13px] " +
  "focus:bg-white focus:border-[#4F46E5] focus:ring-2 focus:ring-[#EDE8FF] outline-none transition-colors resize-none";

export function Field({ label, required, full, children }) {
  return (
    <div className={full ? 'sm:col-span-2' : ''}>
      <label className="text-[12px] font-semibold text-[#4A4B63] block mb-1.5">
        {label}{required && <span className="text-[#EF4444] ml-0.5">*</span>}
      </label>
      {children}
    </div>
  );
}
